export function canConfirmDeleteAccount(
	confirmationPhrase: string,
	expectedPhrase: string,
	isSubmitting: boolean,
): boolean {
	return !isSubmitting && confirmationPhrase === expectedPhrase
}
